import { render } from "./QuestionnaireSimple.vue?vue&type=template&id=0f723ab1&scoped=true"
import script from "./QuestionnaireSimple.vue?vue&type=script&lang=js"
export * from "./QuestionnaireSimple.vue?vue&type=script&lang=js"

import "./QuestionnaireSimple.vue?vue&type=style&index=0&id=0f723ab1&lang=scss&scoped=true"
import "./QuestionnaireSimple.vue?vue&type=style&index=1&id=0f723ab1&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f723ab1"]])

export default __exports__